import { notification } from "antd";

import codeMessage from "./codeMessage";

const successHandler = (response, typeNotification = {}) => {
  const { data, status } = response || {};

  // If HTTP status indicates error, show error notification and return data
  if (status && status >= 400) {
    const message = data && data.message;
    const errorText = message || codeMessage[status];
    notification.config({ duration: 20 });
    notification.error({ message: `Request error ${status}`, description: errorText });
    return data;
  }

  // If backend explicitly returned success: false, show error
  if (data && data.success === false) {
    const message = data && data.message;
    const errorText = message || codeMessage[status];
    notification.config({ duration: 20 });
    notification.error({ message: `Request error ${status || ''}`.trim(), description: errorText });
    return data;
  }

  // Otherwise treat as success; return the data payload to callers
  return data;
};

export default successHandler;
